module.exports = __webpack_public_path__ + "static/media/W5390484_23.38e747ab.jpg";